<mat-form-field class="form-field" subscriptSizing="dynamic">
    <mat-label>{{label}}</mat-label>
    <input matInput [formControl]="control" [placeholder]="placeholder" [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
        (dateInput)="addEvent('input', $event)" (dateChange)="addEvent('change', $event)">
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>